// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: "reactnative-abac5.firebaseapp.com",
    databaseURL: "https://reactnative-abac5-default-rtdb.firebaseio.com",
    projectId: "reactnative-abac5",
    storageBucket: "reactnative-abac5.appspot.com",
    messagingSenderId: "532943576817",
    appId: "1:532943576817:web:32d64202a4707005125350",
    measurementId: "G-2B4VXGN88L"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = firebase.firestore();
export { db, auth };